<div class="card enabled">
  <div class="card-body p-5">
    <div class="h5">Harbour dues {{ port() }} {{ declarationPeriod() }}</div>
    @if (isAvailable) {
      <p>
        Enter tariff discounts for the port authority in {{ port() }}. To view
        what discounts are available, please
        <a
          [attr.href]="tariffLink()"
          target="_blank"
          class="link-primary text-decoration-underline"
          >check out this page</a
        >.
      </p>
      @if (isHarbourDuesReviewer() && declarationSelected() && externalStatus()) {
        <ng-container [ngTemplateOutlet]="externalStatusTemplate" />
      }
      @if (declarationSent()) {
        <ng-container [ngTemplateOutlet]="sent" />
      } @else {
        <ng-container [ngTemplateOutlet]="not_sent" />
      }
    } @else {
      <ng-container [ngTemplateOutlet]="notAvailable" />
    }
  </div>
</div>

<ng-template #notAvailable>
  @if (hasArrived) {
    <p>
      The harbour dues declaration will be available for filing once the ATA
      (Actual Time of Arrival) has been registered.
    </p>
  } @else {
    <p>
      Filing of the harbour dues declaration has been assigned to
      {{ visit().financialDeclarant.fullName }}.
    </p>
  }
  <p>
    To view or change the financial declarant, go to the
    <a
      [routerLink]="['/details', visit().crn, 'authorise']"
      class="pe-auto link-primary text-decoration-underline"
      >'Authorise Organisations' tab</a
    >.
  </p>
</ng-template>

<ng-template #not_sent>
  <div class="h2">Vessel status</div>
  @if (context.hasDeparted() && declarationSelected()) {
    <div>
      Departed
      {{
        selectedDeclaration().visit.atd
          ? (selectedDeclaration().visit.atd | date: "d MMM yyyy 'at' HH:mm")
          : "Unknown"
      }}
    </div>
  } @else {
    @if (hasArrived && declarationSelected()) {
      <div>
        Arrived
        {{
          selectedDeclaration().visit.ata
            ? (selectedDeclaration().visit.ata | date: "d MMM yyyy 'at' HH:mm")
            : "Unknown"
        }}
      </div>
    }
  }
</ng-template>

<ng-template #sent>
  <div class="mb-3">
    <div class="h2">
      @if (isHarbourDuesReviewer()) {
        Agent Status
      } @else {
        Status
      }
    </div>
    <div>
      <app-task-message-status
        [messageStatus]="declarationTaskMessageStatus()"
        [customLabel]="
          rejectionReason() ? 'Rejected: ' + rejectionReason() : null
        "
        [reason]="rejectionReason()"
        [showTooltip]="false" />
    </div>
  </div>
  @if (accepted() && selectedDeclaration().invoices?.length > 0) {
    <p class="enabled">
      Invoice(s) available.
      <a
        [routerLink]="[]"
        fragment="costs"
        (click)="goToCosts()"
        class="link-primary text-decoration-underline">
        Go to Costs
      </a>.
    </p>
  } @else if (declared() || accepted()) {
    <p>Invoice(s) will be available after acknowledgement.</p>
  }
</ng-template>

<ng-template #externalStatusTemplate>
  <div class="mb-3">
    <div class="h2">BTP Status</div>
    <div>
      <app-harbour-dues-rotterdam-external-status [externalStatus]="externalStatus()" />
    </div>
  </div>
</ng-template>
